<template>
  <b-container class="duval-view" fluid>
    <b-row>
      <b-col>
        <label class="mb-1 mt-2">
          {{ $t('engineering.chromatography.method-parameters.entry-criteria') }}*
        </label>
        <s-input-label-edit
          v-model="parametersCopyProxy.entryCriteria"
          :editable="editMode"
          :formattedValue="criteriaLabel"
        >
          <s-select
            v-model="parametersCopyProxy.entryCriteria"
            :options="criteriaOptions"
            @change="onChangeCriteria"
          />
        </s-input-label-edit>
      </b-col>
    </b-row>
    <b-row v-show="parametersCopyProxy.entryCriteria">
      <b-col>
        <b-button
          class="duval-view__know-more"
          variant="link"
          @click="openCriteriaModal"
        >
          <span>{{ $t('engineering.chromatography.method-parameters.know-more') }}</span>
        </b-button>
      </b-col>
    </b-row>
    <component
      :is="criteriaComponents"
      :parameters-copy.sync="parametersCopyProxy"
      :edit-mode="editMode"
      :validation="validation"
    />
    <criteria-modal
      v-model="showCriteriaModal"
      :entry-criteria="parametersCopyProxy.entryCriteria"
      :title="criteriaTitle"
    />
  </b-container>
</template>

<script>
import CriteriaModal from '@/domain/components/installation/engineering/chromatography/methodsParameters/CriteriaModal';
import GasesLimit from '@/domain/components/installation/engineering/chromatography/methodsParameters/GasesLimit';
import BasedAnotherStandardMethod
  from '@/domain/components/installation/engineering/chromatography/methodsParameters/BasedAnotherStandardMethod';
import { CriteriaDuvalMethods } from 'sigma-mappings';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'DuvalView',
  components: { CriteriaModal },
  props: {
    editMode: {
      type: Boolean,
    },
    parametersCopy: {
      type: Object,
    },
    parameters: {
      type: Object,
    },
    validation: {
      type: Object,
    },
  },
  data: vm => ({
    criteriaOptions: [
      {
        value: CriteriaDuvalMethods.ALWAYS,
        text: vm.$t('engineering.chromatography.method-parameters.always'),
      },
      {
        value: CriteriaDuvalMethods.TREETECH_METHODOLOGY,
        text: vm.$t('engineering.chromatography.method-parameters.treetech-methodology'),
      },
      {
        value: CriteriaDuvalMethods.BASED_ANOTHER_STANDARD_METHOD,
        text: vm.$t('engineering.chromatography.method-parameters.based-another-standard-method'),
      },
      {
        value: CriteriaDuvalMethods.GASES_LIMIT,
        text: vm.$t('engineering.chromatography.method-parameters.gases-limit'),
      },
    ],
    showCriteriaModal: false,
  }),
  computed: {
    criteriaComponents() {
      const components = {
        [CriteriaDuvalMethods.BASED_ANOTHER_STANDARD_METHOD]: BasedAnotherStandardMethod,
        [CriteriaDuvalMethods.GASES_LIMIT]: GasesLimit,
      };
      return components[this.parametersCopyProxy.entryCriteria];
    },
    parametersCopyProxy: {
      get() {
        return this.parametersCopy || {};
      },
      set(value) {
        this.$emit('update:parameters-copy', value);
      },
    },
    criteriaLabel() {
      if (!this.parametersCopyProxy.entryCriteria) {
        return '-';
      }
      return this.criteriaTitle;
    },
    criteriaTitle() {
      const criteriaOption = this.criteriaOptions
        .find(criteria => criteria.value === this.parametersCopyProxy.entryCriteria) || {};
      return criteriaOption.text;
    },
  },
  methods: {
    openCriteriaModal() {
      this.showCriteriaModal = true;
    },
    setOriginalParametersExceptCriteria() {
      const originalParameters = cloneDeep(this.parameters);
      originalParameters.entryCriteria = this.parametersCopyProxy.entryCriteria;
      this.parametersCopyProxy = originalParameters;
    },
    onChangeCriteria() {
      this.setOriginalParametersExceptCriteria();
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .duval-view
    padding: 0
    &__know-more
      color: $color-link
      padding: 0
      font-size: .9rem
      &:focus
        box-shadow: none
        text-decoration: none
    ::v-deep
      .label-edit_viewing
        opacity: .5
</style>
